import _classCallCheck from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import Page from "../components/base/Page";
import ErrorTracker from "../state/utils/ErrorTracker";
import ErrorTemplate from "../components/base/Error";
export var Error = /*#__PURE__*/function (_React$Component) {
  _inherits(Error, _React$Component);
  var _super = _createSuper(Error);
  function Error() {
    _classCallCheck(this, Error);
    return _super.apply(this, arguments);
  }
  _createClass(Error, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var err = this.props.err;
      if (err) {
        ErrorTracker.sendException(err);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ErrorTemplate, this.props);
    }
  }], [{
    key: "getInitialProps",
    value: function getInitialProps(_ref) {
      var res = _ref.res,
        err = _ref.err;
      var statusCode = res ? res.statusCode : err ? err.statusCode : 404;
      return {
        statusCode: statusCode,
        err: err,
        hasGetInitialPropsRun: true
      };
    }
  }, {
    key: "propTypes",
    get: function get() {
      return {
        err: PropTypes.object
      };
    }
  }]);
  return Error;
}(React.Component);
export default Page(Error);